/**
 * Next Level Theme JavaScript
 * Main entry point for all JS
 */

// Add your global JavaScript here

// Example: Mobile menu toggle
jQuery(document).ready(function($) {
    $('#desktop-search-toggle').click(function() {
        $('.header-nav-wrapper').toggleClass('is-hidden');
        $('.header-search-wrapper').toggleClass('is-visible');
        setTimeout(function() {
            $('.header-search-input').focus();
        }, 50);
    });
});